// Main menu items (header). `mobileOnly` items show only in the collapsed mobile menu.
const navigation = [
  { label: "Home", to: "/" },
  { label: "About Us", to: "/about" },
  { label: "Packages", to: "/packages" },
  { label: "Services", to: "/services" },
  { label: "Our Consultants", to: "/doctors" },
  { label: "Contact Us", to: "/contact" },
  {
    label: "More",
    children: [
      { label: "Gallery", to: "/gallery" },
      { label: "Blogs", to: "/blog" },
      { label: "Doctors' Timetable", to: "/time-table" },
      { label: "Free Self-Assessment", to: "/self-assessment" },
      { label: "Admission Enquiry", to: "/admission" },
    ],
  },
  { label: "Appointment", to: "/appointment", mobileOnly: true },
];

export default navigation;
